import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-to_top",
  "use": "icon-to_top-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-to_top\"><defs><style type=\"text/css\"></style></defs><path d=\"M511.937 238.061l-323.444 323.517 208.002-0.119 0.595 369.463 230.121 0.29v-369.774l208.295 0.14-323.566-323.517zM188.495 92.789h647.009v82.875h-647.009v-82.875z\" p-id=\"4121\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol